export default __webpack_public_path__ + "img/csOdMlOo.b580444d.svg";